export default {
  review_the_user_terms: 'Review the User Terms',
  footer_agreement_note:
    'By choosing "{agree}", you understand and agree to Flock\'s {terms} and {privacyPolicy}',
  i_agree: 'I Agree',
  terms_of_use: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
};
